var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMedicalVids(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2639_5531)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M6.47293 14.0248H3.30793C1.48385 14.0248 0.458696 12.0746 1.97687 11.0634C3.33865 10.1565 4.97406 9.62787 6.73293 9.62787C7.0122 9.62787 7.28835 9.6412 7.56079 9.66724",
    stroke: "black",
    strokeWidth: 1.29,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.73299 7.4493C8.71939 7.4493 9.83675 6.33194 9.83675 4.34552C9.83675 2.35911 8.71939 1.24176 6.73299 1.24176C4.74657 1.24176 3.62921 2.35911 3.62921 4.34552C3.62921 6.33194 4.74657 7.4493 6.73299 7.4493Z",
    stroke: "black",
    strokeWidth: 1.29,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.109 16.717C11.6057 16.6643 11.2435 16.2284 11.2277 15.7227C11.2155 15.3351 11.2058 14.9514 11.1986 14.5699C10.8129 14.5626 10.4249 14.5529 10.033 14.5406C9.52731 14.5248 9.09143 14.1626 9.03873 13.6593C8.98375 13.1344 8.98375 12.6245 9.03873 12.0996C9.09143 11.5964 9.52732 11.2342 10.033 11.2184C10.4249 11.2061 10.8129 11.1963 11.1986 11.189C11.2058 10.8073 11.2155 10.4233 11.2277 10.0355C11.2435 9.52978 11.6057 9.09389 12.109 9.04121C12.6339 8.98626 13.1437 8.98626 13.6686 9.04121C14.1718 9.09389 14.5341 9.52978 14.5498 10.0355C14.562 10.4235 14.5717 10.8076 14.579 11.1895C14.9574 11.1967 15.3382 11.2063 15.7226 11.2184C16.2284 11.2342 16.6643 11.5964 16.7169 12.0996C16.7719 12.6245 16.7719 13.1344 16.7169 13.6593C16.6643 14.1626 16.2284 14.5248 15.7226 14.5406C15.3382 14.5526 14.9574 14.5623 14.579 14.5694C14.5717 14.951 14.562 15.335 14.5498 15.7227C14.5341 16.2284 14.1718 16.6643 13.6686 16.717C13.1437 16.7719 12.6339 16.7719 12.109 16.717Z",
    stroke: "black",
    strokeWidth: 1.29,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2639_5531"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 18,
    height: 18,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMedicalVids);
export default __webpack_public_path__ + "static/media/medicalVids.227b402e391fff19a9364494f3fbe92b.svg";
export { ForwardRef as ReactComponent };